var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c("div", {
        staticClass: "overlay",
        class: { hidden: !_vm.overlayVisible },
      }),
      _vm._v(" "),
      _c("EditInputField", {
        attrs: {
          "field-type": "text",
          "field-label": _vm.t("cookbook", "Name"),
        },
        model: {
          value: _vm.recipe["name"],
          callback: function ($$v) {
            _vm.$set(_vm.recipe, "name", $$v)
          },
          expression: "recipe['name']",
        },
      }),
      _vm._v(" "),
      _c("EditInputField", {
        attrs: {
          "field-type": "markdown",
          "field-label": _vm.t("cookbook", "Description"),
          "reference-popup-enabled": true,
        },
        model: {
          value: _vm.recipe["description"],
          callback: function ($$v) {
            _vm.$set(_vm.recipe, "description", $$v)
          },
          expression: "recipe['description']",
        },
      }),
      _vm._v(" "),
      _c("EditInputField", {
        attrs: { "field-type": "url", "field-label": _vm.t("cookbook", "URL") },
        model: {
          value: _vm.recipe["url"],
          callback: function ($$v) {
            _vm.$set(_vm.recipe, "url", $$v)
          },
          expression: "recipe['url']",
        },
      }),
      _vm._v(" "),
      _c("EditImageField", {
        attrs: { "field-label": _vm.t("cookbook", "Image") },
        model: {
          value: _vm.recipe["image"],
          callback: function ($$v) {
            _vm.$set(_vm.recipe, "image", $$v)
          },
          expression: "recipe['image']",
        },
      }),
      _vm._v(" "),
      _c("EditTimeField", {
        attrs: { "field-label": _vm.t("cookbook", "Preparation time") },
        model: {
          value: _vm.prepTime,
          callback: function ($$v) {
            _vm.prepTime = $$v
          },
          expression: "prepTime",
        },
      }),
      _vm._v(" "),
      _c("EditTimeField", {
        attrs: { "field-label": _vm.t("cookbook", "Cooking time") },
        model: {
          value: _vm.cookTime,
          callback: function ($$v) {
            _vm.cookTime = $$v
          },
          expression: "cookTime",
        },
      }),
      _vm._v(" "),
      _c("EditTimeField", {
        attrs: { "field-label": _vm.t("cookbook", "Total time") },
        model: {
          value: _vm.totalTime,
          callback: function ($$v) {
            _vm.totalTime = $$v
          },
          expression: "totalTime",
        },
      }),
      _vm._v(" "),
      _c("EditMultiselect", {
        attrs: {
          "field-label": _vm.t("cookbook", "Category"),
          placeholder: _vm.t("cookbook", "Choose category"),
          options: _vm.allCategories,
          taggable: true,
          multiple: false,
          loading: _vm.isFetchingCategories,
        },
        on: { tag: _vm.addCategory },
        model: {
          value: _vm.recipe["recipeCategory"],
          callback: function ($$v) {
            _vm.$set(_vm.recipe, "recipeCategory", $$v)
          },
          expression: "recipe['recipeCategory']",
        },
      }),
      _vm._v(" "),
      _c("EditMultiselect", {
        attrs: {
          "field-label": _vm.t("cookbook", "Keywords"),
          placeholder: _vm.t("cookbook", "Choose keywords"),
          options: _vm.allKeywords,
          taggable: true,
          multiple: true,
          "tag-width": 60,
          loading: _vm.isFetchingKeywords,
        },
        on: { tag: _vm.addKeyword },
        model: {
          value: _vm.selectedKeywords,
          callback: function ($$v) {
            _vm.selectedKeywords = $$v
          },
          expression: "selectedKeywords",
        },
      }),
      _vm._v(" "),
      _c("EditInputField", {
        attrs: {
          "field-type": "number",
          "field-label": _vm.t("cookbook", "Servings"),
        },
        model: {
          value: _vm.recipe["recipeYield"],
          callback: function ($$v) {
            _vm.$set(_vm.recipe, "recipeYield", $$v)
          },
          expression: "recipe['recipeYield']",
        },
      }),
      _vm._v(" "),
      _c("EditMultiselectInputGroup", {
        attrs: {
          "field-label": _vm.t("cookbook", "Nutrition Information"),
          options: _vm.availableNutritionFields,
          "label-select-placeholder": _vm.t("cookbook", "Pick option"),
        },
        model: {
          value: _vm.recipe["nutrition"],
          callback: function ($$v) {
            _vm.$set(_vm.recipe, "nutrition", $$v)
          },
          expression: "recipe['nutrition']",
        },
      }),
      _vm._v(" "),
      _c("EditInputGroup", {
        attrs: {
          "field-name": "tool",
          "field-type": "text",
          "field-label": _vm.t("cookbook", "Tools"),
          "create-fields-on-newlines": true,
          "reference-popup-enabled": true,
        },
        model: {
          value: _vm.recipe["tool"],
          callback: function ($$v) {
            _vm.$set(_vm.recipe, "tool", $$v)
          },
          expression: "recipe['tool']",
        },
      }),
      _vm._v(" "),
      _c("EditInputGroup", {
        attrs: {
          "field-name": "recipeIngredient",
          "field-type": "text",
          "field-label": _vm.t("cookbook", "Ingredients"),
          "create-fields-on-newlines": true,
          "reference-popup-enabled": true,
        },
        model: {
          value: _vm.recipe["recipeIngredient"],
          callback: function ($$v) {
            _vm.$set(_vm.recipe, "recipeIngredient", $$v)
          },
          expression: "recipe['recipeIngredient']",
        },
      }),
      _vm._v(" "),
      _c("EditInputGroup", {
        attrs: {
          "field-name": "recipeInstructions",
          "field-type": "textarea",
          "field-label": _vm.t("cookbook", "Instructions"),
          "create-fields-on-newlines": true,
          "show-step-number": true,
          "reference-popup-enabled": true,
        },
        model: {
          value: _vm.recipe["recipeInstructions"],
          callback: function ($$v) {
            _vm.$set(_vm.recipe, "recipeInstructions", $$v)
          },
          expression: "recipe['recipeInstructions']",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "cookbook-footer" }, [
        _c(
          "button",
          {
            staticClass: "button",
            on: {
              click: function ($event) {
                return _vm.save()
              },
            },
          },
          [
            _c("span", {
              class: _vm.$store.state.savingRecipe
                ? "icon-loading-small"
                : "icon-checkmark",
            }),
            _vm._v(
              "\n            " +
                _vm._s(_vm.t("cookbook", "Save changes")) +
                "\n        "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("edit-multiselect-popup", {
        ref: "referencesPopup",
        staticClass: "references-popup",
        class: { visible: _vm.referencesPopupFocused },
        attrs: {
          options: _vm.allRecipeOptions,
          "track-by": "recipe_id",
          label: "title",
          loading: _vm.loadingRecipeReferences,
          focused: _vm.referencesPopupFocused,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }